import { useEffect, useState } from 'react';

export const TitlePulse = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation after a short delay
    const timer = setTimeout(() => setAnimate(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <svg
        className={`w-80 h-80 transition-all duration-1000 ${
          animate ? 'opacity-0 scale-150' : 'opacity-60 scale-50'
        }`}
        viewBox="0 0 200 200"
      >
        <defs>
          <radialGradient id="pulseGrad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="transparent" />
            <stop offset="70%" stopColor="rgba(0, 242, 255, 0.3)" />
            <stop offset="100%" stopColor="transparent" />
          </radialGradient>
        </defs>
        <circle
          cx="100"
          cy="100"
          r="80"
          fill="url(#pulseGrad)"
          stroke="rgba(0, 242, 255, 0.4)"
          strokeWidth="2"
          className="blur-sm"
        />
      </svg>
    </div>
  );
};
